import { render, staticRenderFns } from "./HomeworkMedia.vue?vue&type=template&id=404bf2ba"
import script from "./HomeworkMedia.vue?vue&type=script&lang=js"
export * from "./HomeworkMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports